export class AssetsHelper {
  static logo = 'assets/images/logo.svg';
  static eemoIcon = 'assets/images/eemo-icon.svg';
  static sendIcon = 'assets/images/send.svg';
}
